$(document).ready(function() {
	
	$(".accordion-toggle").click(function() {		
		if($(this).hasClass("open"))
		{
			$(this).removeClass("open");
			$(this).closest(".accordion-container").find(".accordion-content").slideUp("fast");
			$(this).closest(".accordion-container").find(".accordion-icon").html("+");
		}
		else
		{
			$(".accordion-toggle").removeClass("open");
			$(".accordion-content").slideUp("fast");
			$(".accordion-icon").html("+");
			$(this).addClass("open");
			$(this).closest(".accordion-container").find(".accordion-content").slideDown("fast");
			$(this).closest(".accordion-container").find(".accordion-icon").html("&mdash;");
		}				
	});
	$(".accordion-icon").click(function() {		
		$(this).closest(".accordion-container").find(".accordion-toggle").click();
	});
	$(".page-more-more").click(function() {		
		$(this).hide();
		$(this).closest(".page-more").find(".page-more-content").show();
		$(this).closest(".page-more").find(".page-more-dots").hide();
		$(this).closest(".page-more").find(".page-more-less").show();
	});
	$(".page-more-less").click(function() {		
		$(this).hide();
		$(this).closest(".page-more").find(".page-more-content").hide();
		$(this).closest(".page-more").find(".page-more-dots").show();
		$(this).closest(".page-more").find(".page-more-more").show();
	});
	$(".object-pages .prev a").html("&lt;")
	$(".object-pages .next a").html("&gt;")
		
});